import { fromJS } from 'immutable';
import * as types from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const designSettingsDefault = {
  upsellPopup: {
    settings: {
      languageAddToCart: 'Add to cart',
      languageVariantSoldOut: 'Sold out',
      languageNoThankText: 'No thanks',
      languageCheckOutText: 'Check out',
      languageMessageWhenCustomerAddedAllOfferProduct: 'You have added all upsell products to the cart.',
      languageMessageWhenAddProductButSolidOut: 'Sorry! This item is sold out',
      dontShowOutStocks: false,
      dontShowProductAddedToCart: false,
      maximumItemsInPopup: false,
      maximumItemsValueInPopup: 10
    },
    design: {
      // Box modal
      boxBackgroundColor: '#ffffff',
      // Offer message
      offerMessageColor: '#212b36',
      // Upsell product
      productNameColor: '#212b36',
      productPriceColor: '#212b36',
      productComparePriceColor: '#666666',
      // Button add to cart
      addToCartButtonBgColor: '#2862F6',
      addToCartButtonTextColor: '#ffffff',
      addToCartButtonBorderColor: '#0061ff',
      hoverAddToCartButtonBgColor: '#2B27FF',
      hoverAddToCartButtonTextColor: '#ffffff',
      hoverAddToCartBorderColor: '#0061ff',
      // Close button design
      closeButtonBackground: '#666',
      closeIconColor: '#ffffff',
      hoverCloseButtonBackground: '#000',
      // No thank
      noThankTextColor: '#999999',
      hoverNoThankTextColor: '#666666'
    }
  },
  upsellBundle: {
    settings: {
      languageTotalPrice: 'Total price',
      languageAddNumberToCart: 'Add all to cart',
      languageWhenSoldOut: 'Sorry! This item is sold out',
      languageVariantSoldOut: 'Sold out'
    },
    design: {
      checkBoxBackgroundColor: '#0679F4',
      offerMessageColor: '#55586c',
      productNameColor: '#55586c',
      priceColor: '#55586c',
      priceCompareColor: '#666666',
      totalTextColor: '#111111',
      totalPriceColor: '#111111',
      totalComparePriceColor: '#69727b',
      buttonBackgroundColor: '#0679F4',
      buttonTextColor: '#ffffff',
      hoverButtonBackgroundColor: '#2B27FF',
      hoverButtonTextColor: '#FFFFFF'
    }
  },
  otherSettings: {
    settings: {
      congratsMessageOnCart: 'Congratulations! You saved {{amount_save}}',
      showForCustomerLogged: false,
      showProductLinks: false
    }
  },
  version: 2,
  getDesignSettingsLoading: true,
  saveSettingLoading: false,
  saveSettingResult: 0
};

const defaultState = fromJS(designSettingsDefault);

let data = '';

const designReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.GET_GLOBAL_SETTING:
      return state.set('getDesignSettingsLoading', true);
    case types.GET_GLOBAL_SETTING_RESULT:
      if (action.res) {
        return state
          .set('upsellPopup', fromJS(action.res.upsellPopup))
          .set('upsellBundle', fromJS(action.res.upsellBundle))
          .set('otherSettings', fromJS(action.res.otherSettings))
          .set('getDesignSettingsLoading', false);
      }
      return state.set('getDesignSettingsLoading', false);
    case types.CHANGE_DESIGN_SETTINGS_FIELD:
      data = action.payload;
      return state.setIn([data.upsell, data.type, data.field], data.value);
    case types.CHANGE_DESIGN_FIELD:
      return state.set(action.payload.field, action.payload.value);
    case types.SAVE_SETTING_DESIGN:
      return state.set('saveSettingLoading', true);
    case types.SAVE_SETTING_DESIGN_RESULT:
      return state.set('saveSettingLoading', false).set('saveSettingResult', action.res);
    case types.RESET_DESIGN_SETTING:
      return state
        .setIn(['upsellPopup', 'design'], fromJS(designSettingsDefault.upsellPopup.design))
        .setIn(['upsellBundle', 'design'], fromJS(designSettingsDefault.upsellBundle.design));
    default:
      return state;
  }
};

export default designReducer;
